/* =====================================================================
   juizs-cart.js — OD-015
   ---------------------------------------------------------------------
   Eén eigen winkelwagenlaag. Bewust NIET op Dawn gebouwd: `cart_type`
   blijft op `notification`, Dawn's cart-drawer.js/cart.js worden niet
   geladen en verdwijnen later helemaal.

   Twee delen:
   1. JuizsOverlay — gedeelde overlay-mechaniek (focus-trap, Esc, scroll-
      lock, focus terug naar de opener). Ook gebruikt door de ingrediënt-
      modal (OD-001) via window.JuizsOverlay.
   2. De winkelwagen-lade — onderschept elk `/cart/add`-formulier, praat
      met /cart/add.js en /cart/change.js, en laat Shopify de sectie
      meteen meerenderen (`sections`-parameter) zodat één request volstaat.

   Werkt zonder JS: elk formulier submit dan gewoon naar /cart, elke
   verwijderlink is een echte href, en de lade-opener is de bestaande
   link naar /cart.

   Custom event (tracking-wiki 70-tracking):
     document → 'juizs:add-to-cart'  detail: { items, cart, source }
   ===================================================================== */
(function () {
  'use strict';

  var SECTION_ID = 'juizs-cart-drawer';
  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  /* ---------------------------------------------------------------
     1. JuizsOverlay — gedeelde mechaniek
     --------------------------------------------------------------- */
  var scrollLocks = 0;

  function lockScroll() {
    scrollLocks += 1;
    if (scrollLocks === 1) document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (scrollLocks === 0) document.body.style.overflow = '';
  }

  function Overlay(root) {
    this.root = root;
    this.panel = root.querySelector('[role="dialog"]') || root;
    this.scrim = root.querySelector('.juizs-ovl-scrim');
    this.opener = null;
    this.isOpen = false;

    this.onKeydown = this.handleKeydown.bind(this);

    var self = this;
    root.addEventListener('click', function (e) {
      // Sluiten bij: een expliciete sluitknop, de donkere achtergrond, of het
      // overlay-vlak zelf. Die laatste twee zijn nodig omdat een klik naast het
      // paneel niet altijd op de scrim landt (bevinding 29-07).
      var closer = e.target.closest('[data-juizs-overlay-close]');
      var outside = e.target === self.root || e.target === self.scrim;
      if (closer || outside) {
        e.preventDefault();
        self.close();
      }
    });
  }

  Overlay.prototype.focusables = function () {
    return Array.prototype.slice
      .call(this.panel.querySelectorAll(FOCUSABLE))
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
  };

  Overlay.prototype.handleKeydown = function (e) {
    if (!this.isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key !== 'Tab') return;

    var items = this.focusables();
    if (!items.length) {
      e.preventDefault();
      this.panel.focus();
      return;
    }

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  Overlay.prototype.open = function (opener) {
    if (this.isOpen) return;
    this.opener = opener || document.activeElement;
    this.isOpen = true;

    this.root.removeAttribute('inert');
    this.root.setAttribute('aria-hidden', 'false');
    // Eerst zichtbaar maken, dán de transitie starten.
    this.root.classList.add('is-open');

    lockScroll();
    document.addEventListener('keydown', this.onKeydown);

    var items = this.focusables();
    (items[0] || this.panel).focus();
  };

  Overlay.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    this.root.setAttribute('inert', '');

    unlockScroll();
    document.removeEventListener('keydown', this.onKeydown);

    if (this.opener && document.contains(this.opener)) this.opener.focus();
    this.opener = null;
  };

  /* Focus terugzetten als de inhoud onder je handen is vervangen. */
  Overlay.prototype.restoreFocus = function (previous) {
    if (!this.isOpen) return;
    if (previous && document.contains(previous)) return;
    var items = this.focusables();
    (items[0] || this.panel).focus();
  };

  window.JuizsOverlay = Overlay;

  /* ---------------------------------------------------------------
     2. De winkelwagen-lade
     --------------------------------------------------------------- */
  var root = document.querySelector('[data-juizs-drawer]');
  if (!root) return;

  var overlay = new Overlay(root);
  var contentsSelector = '[data-juizs-drawer-contents]';

  function contents() {
    return root.querySelector(contentsSelector);
  }

  function setBusy(state) {
    var el = contents();
    if (el) el.classList.toggle('is-busy', !!state);
  }

  /* Kop-teller bijwerken. De header rendert de badge alleen bij >0, dus
     hij wordt hier zo nodig aangemaakt of verwijderd. */
  function updateCount(count) {
    var link = document.querySelector('[data-juizs-cart-open], .juizs-header-cart');
    if (!link) return;

    var badge = link.querySelector('[data-juizs-cart-count], .juizs-header-cart-badge');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'juizs-header-cart-badge';
        badge.setAttribute('data-juizs-cart-count', '');
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }

    link.setAttribute('aria-label', 'Winkelwagen' + (count > 0 ? ' — ' + count + ' items' : ''));
  }

  /* Inhoud van de lade vervangen zonder de dialoog-schil kwijt te raken. */
  function swapContents(html) {
    var current = contents();
    if (!current || !html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(contentsSelector);
    if (!fresh) return;

    var wasFocused = document.activeElement;
    current.innerHTML = fresh.innerHTML;
    overlay.restoreFocus(wasFocused);
  }

  /* Antwoord van /cart/*.js verwerken: sectie-HTML + teller. */
  function applyCartResponse(data) {
    if (!data) return;

    if (data.sections && data.sections[SECTION_ID]) {
      swapContents(data.sections[SECTION_ID]);
    } else {
      // Terugval: sectie los ophalen (bv. als de sections-parameter faalt).
      fetch(window.Shopify.routes.root + '?sections=' + SECTION_ID)
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          swapContents(json[SECTION_ID]);
        })
        .catch(function () {});
    }

    if (typeof data.item_count === 'number') updateCount(data.item_count);
  }

  function refreshCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCount(cart.item_count);
      })
      .catch(function () {});
  }

  /* ---- Openen ---- */
  function openDrawer(opener) {
    overlay.open(opener);
  }

  /* ---- Publieke API ----
     Voor koopwegen die NIET via een gewone form-submit lopen — zoals de
     add-on-flow in de buy-box, die meerdere regels in een atomaire
     /cart/add.js zet. Die roept `window.JuizsCart.addItems(items, knop)`
     aan in plaats van door te sturen naar /cart. */
  function addItems(items, opener) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: items,
        sections: SECTION_ID,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      })
      .then(function (added) {
        document.dispatchEvent(
          new CustomEvent('juizs:add-to-cart', {
            detail: { items: added.items || [added], source: 'api' },
          })
        );
        applyCartResponse(added);
        if (!added.sections || !added.sections[SECTION_ID]) refreshCount();
        openDrawer(opener);
        return added;
      });
  }

  window.JuizsCart = {
    open: openDrawer,
    close: function () {
      overlay.close();
    },
    addItems: addItems,
    refreshCount: refreshCount,
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-juizs-cart-open], .juizs-header-cart');
    if (!opener) return;
    e.preventDefault();
    openDrawer(opener);
  });

  /* ---- Toevoegen: elk /cart/add-formulier onderscheppen ----
     Capture-fase, zodat Dawn's <product-form> er niet meer aan toekomt
     (die stuurt zonder cart-element hard door naar /cart). */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.hasAttribute('data-juizs-skip-ajax')) return;

      e.preventDefault();
      e.stopPropagation();

      var formData = new FormData(form);
      formData.append('sections', SECTION_ID);
      formData.append('sections_url', window.location.pathname);

      var submitter = form.querySelector('[type="submit"]');
      if (submitter) submitter.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData,
      })
        .then(function (r) {
          return r.json().then(function (json) {
            if (!r.ok) throw json;
            return json;
          });
        })
        .then(function (added) {
          document.dispatchEvent(
            new CustomEvent('juizs:add-to-cart', {
              detail: { items: added.items || [added], source: 'form' },
            })
          );
          applyCartResponse(added);
          if (!added.sections || !added.sections[SECTION_ID]) refreshCount();
          openDrawer(submitter);
        })
        .catch(function (err) {
          // Foutmelding van Shopify (bv. voorraad) — val terug op de
          // gewone submit zodat de klant hoe dan ook verder komt.
          if (window.console && err) window.console.warn('[juizs-cart]', err);
          form.setAttribute('data-juizs-skip-ajax', '');
          form.submit();
        })
        .finally(function () {
          if (submitter) submitter.classList.remove('is-loading');
        });
    },
    true
  );

  /* ---- Aantal wijzigen en verwijderen binnen de lade ---- */
  function changeLine(key, quantity) {
    setBusy(true);
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartResponse(cart);
        document.dispatchEvent(new CustomEvent('juizs:cart-change', { detail: { cart: cart } }));
      })
      .catch(function () {
        window.location.href = root.getAttribute('data-cart-url') || '/cart';
      })
      .finally(function () {
        setBusy(false);
      });
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-juizs-qty]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10));
      return;
    }

    var remove = e.target.closest('[data-juizs-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-key'), 0);
    }
  });

  /* De lade leeft buiten de sectie-boom van de editor; bij een sectie-
     herlading in de theme-editor de teller opnieuw ophalen. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === SECTION_ID) return;
    refreshCount();
  });
})();
